import { CMSChildrenContainer } from '@/cmsComponents/ChildrenContainer';
import { MarkdownContent } from '@/cmsComponents/MarkdownContent';
import { SingleCoverComponent } from '@/cmsComponents/SingleCoverComponent';
import { CMSContainer } from '@/modules/CMSContainer';
import { getTermsAndConditions } from '@/services/cmsService';
import { ITermsAndConditions } from '@/types/cms';
import { tryToNoticeError } from '@/utils/errorInfo';
import { NextSeo } from 'next-seo';
import React from 'react';

interface IProps {
  terms: ITermsAndConditions;
}

const TermsAndConditions = ({ terms }: IProps) => {
  const { content, meta_title, meta_description, cover_collection, index } = terms;

  return (
    <CMSContainer>
      <NextSeo
        title={meta_title}
        description={meta_description}
        openGraph={{
          title: meta_title,
          description: meta_description,
        }}
        noindex={!index}
        nofollow={!index}
      />
      {cover_collection && <SingleCoverComponent {...cover_collection} />}
      <CMSChildrenContainer>{content && <MarkdownContent source={content} />}</CMSChildrenContainer>
    </CMSContainer>
  );
};

export async function getServerSideProps(ctx) {
  try {
    const terms = await getTermsAndConditions();

    if (terms?.redirect_url) {
      const { res } = ctx;
      if (res) {
        res.writeHead(301, { Location: terms?.redirect_url });
        res.end();
      }
    }

    return {
      props: { terms },
    };
  } catch (error) {
    const errorMessage = `Terms and Conditions Page Data Error: ${error.message}`;
    tryToNoticeError(new Error(errorMessage, { cause: error }), { error });
    return { notFound: true };
  }
}

export default TermsAndConditions;
